// src/api/walletApi.js
import api from "../configs/axiosConfig";

// POST /wallet/transfer
export async function transferMoney(payload, userId) {
  const response = await api.post(`/transfer_money/money_transfer_request/${userId}`, payload);
  
  return response.data;
}

// POST /wallet/withdraw
export async function withdrawMoney(payload,userId) {
  const response = await api.post(`/withdraw_money/send_withdraw_request/${userId}`, payload);
  return response.data;
}

// GET /wallet/overview/:user_id
export async function getWalletOverview(userId) {
  const response = await api.get(`/wallet/get_user_wallet/${userId}`);
  return response.data;
}

// GET /wallet/history/:user_id
export async function getWalletHistory(userId) {
  const response = await api.get(`/wallet/get_user_wallet_history/${userId}`);
  return response.data;
}

// NEW: get monthly withdraw limit status
export async function getWithdrawLimit(userId) {
  const res = await api.get(`/withdraw_money/${userId}/withdraw/limit`);
  return res.data; // { success, used, limit, remaining }
}

